export default "* Hvad er et hulemaleri?\n* Hvad viser hulemaleriet?\n* Hvad kan hulemaleriet fortælle os?\n* Hvem har lavet hulemaleriet?\n";